var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "alfapaymentstatus-component" }, [
    _c("div", { staticClass: "payment-status-window" }, [
      _c("div", { staticClass: "payment-status-window__message" }, [
        _vm._v("\n      " + _vm._s(_vm.resultMessage) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.timer
        ? _c("div", { staticClass: "payment-status-window__loading" }, [
            _c("i", {
              staticClass:
                "fa fa-ellipsis fa-beat payment-status-window__loading-icon",
            }),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }